
























import { Vue, Component, Prop, Emit, Ref } from 'vue-property-decorator';
import { gridProps, gridOption, taskMessagesGridDataInit, INIT_PAGE } from './MessageListValues';
import ItemTable from '@/components/common/ItemTable.vue';
import { GridEventProps } from 'tui-grid/types/event';

@Component({
  components: {
    ItemTable
  }
})
export default class MessageListBottom extends Vue {
  @Ref()
  private readonly gridRef: ItemTable;
  @Prop({ required: true })
  private readonly taskMessages = taskMessagesGridDataInit;
  @Prop({ required: true })
  private readonly totalCount = 0;
  @Emit('changePerPage')
  private changePerPage(page: number, size?: number){
    const pageOptions = this.gridProps.options.pageOptions;

    if (size) {
      pageOptions.perPage = size;
      pageOptions.page = INIT_PAGE;
    } else {
      pageOptions.page = page;
    }

    return { 
      page: pageOptions.page,
      size: pageOptions.perPage
    }
  }

  private readonly gridOption = gridOption;
  private readonly request = { params: {} };
  private gridProps = gridProps();

  private onItemClicked({ columnName, rowKey } :GridEventProps) {
     if (columnName === 'orderNo') {
      const { orderNo } = this.gridRef.getRow(rowKey);
      window.open(`/order/detail?orderNo=${orderNo}`, '_blank');
    }
  }
}
